import ClearIcon from "@mui/icons-material/Clear";
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import {
  Backdrop,
  Box,
  Button,
  CircularProgress,
  Grid,
  Typography,
  TextField,
  InputAdornment,
  MenuItem,
  Menu,
  ListItemIcon,
  ListItemText,
  Divider,
  Select,
  Modal,
} from "@mui/material";
import EditNoteIcon from "@mui/icons-material/EditNote";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RadioGroup from "@mui/material/RadioGroup";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import LockResetIcon from "@mui/icons-material/LockReset";
import Person4OutlinedIcon from "@mui/icons-material/Person4Outlined";
import PasswordRoundedIcon from "@mui/icons-material/PasswordRounded";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import SaveIcon from "@mui/icons-material/Save";
import ContactEmergencyIcon from "@mui/icons-material/ContactEmergency";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import PersonIcon from "@mui/icons-material/Person";
import AddCardIcon from "@mui/icons-material/AddCard";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import EmailIcon from "@mui/icons-material/Email";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import { styled } from "@mui/material/styles";
import moment from "moment/moment";
import { Snackbar, Alert } from "@mui/material";
import Error from "../../../components/error/error";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import CheckPermissions from "../../../authorization/authorization";
import ToggleButton from "../../../components/ToggleButton/ToggleButton";
import BasicTable from "../../../components/basicTable/basicTable";
import {
  fetchPaginatedUsers,
  firstPage,
  lastPage,
  nextPage,
  previousPage,
} from "../../../features/accessManagement/usersSlice";
import { AllCFCs } from "../../../network/APIs/APIs";
import { cfpBaseUrl } from "../../../network/urls";
import { tableStyle } from "../../../style/common";
import { AllRoles } from "../../../network/APIs/APIs";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import {
  colors,
  allCFCLevelsAPI,
  allCompaniesAPI,
  allEmployeeRoleTypes,
  handleFileUpload,
  isImage,
  isPdf,
} from "../../../services/Functions";
import "./UserManagement.scss";
import * as Yup from "yup";
import { useFormik } from "formik";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import { passwordRegex } from "../../../../src/utils/PortalName";
import ChangePasswordIcon from "../../../../src/images/reset-password.png";
import UserIconImage from "../../../images/user.jpg";
import pdfIcon from "../../../images/pdfIcon.png";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import { documentExtensions, portalName } from "../../../utils/PortalName";
import UpdateUserPopup from "../../../components/UpdateUserPopup/updateUserPopup";
import TransferWithinAStationIcon from "@mui/icons-material/TransferWithinAStation";
export default function UserManagementTable(props) {
  //#region
  const [newusersToDataGrid, setNewUsersToDataGrid] = useState([]);
  const dispatch = useDispatch();
  const [openTransferPopup, setOpenTransferPopup] = useState(false);
  const [userToEdit, setUserToEdit] = useState(null);

  const [open, setOpen] = useState(false);
  const [open2, setopen2] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [dialogRowData, setDialogRowData] = React.useState({});
  const [showNewPassword, setShowNewPassword] = React.useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);
  const [dltuser, setdltuser] = useState();
  const Navigate = useNavigate();
  // Add these near your other dialog states
  const [openTransferSuccessModal, setOpenTransferSuccessModal] =
    useState(false);
  const [transferSuccessMessage, setTransferSuccessMessage] = useState("");
  const [selectedUser, setSelectedUser] = useState(null);
  const [showChangePasswordPopup, setShowChangePasswordPopup] = useState(false);
  const {
    token,
    permissions,
    code: officeCode,
    hierarchy,
  } = useSelector((state) => state.auth);
  let userCompany = officeCode.slice(0, 2);
  // const subDivisions = JSON.parse(window.localStorage.getItem("subDivisions"));
  const [subDivisions, setSubDivisions] = useState(
    JSON.parse(window.localStorage.getItem("subDivisions")) || [],
  );
  const [viewBackdrop, setViewBackdrop] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [openProfileModalName, setOpenProfileModalName] = useState(false);
  const [openProfileModalPhoneNo, setOpenProfileModalPhoneNo] = useState(false);
  const [openProfileModalEmail, setOpenProfileModalEmail] = useState(false);
  const [openProfileModalCNIC, setOpenProfileModalCNIC] = useState(false);
  const [openProfileModalTransferPosting, setOpenProfileModalTransferPosting] =
    useState(false);
  const [typingTimeout, setTypingTimeout] = useState(null);
  const [noDataFound, setNoDataFound] = useState(false);
  const {
    pageNumber,
    pageSize,
    data: users,
    totalPages,
    totalRecords,
    pageNumber: currentPage,
    isLoading: isLoad,
  } = useSelector((state) => state.users);
  const handleClickShowNewPassword = () => setShowNewPassword((prev) => !prev);
  const handleClickShowConfirmPassword = () =>
    setShowConfirmPassword((prev) => !prev);
  const [apiError, setApiError] = useState("");
  const [showSuccessSnackbar, setShowSuccessSnackbar] = useState(false);
  const [editableFields, setEditableFields] = useState({
    name: false,
    phoneNo: false,
    CNIC: false,
    email: false,
  });
  const [selectedRoleType, setSelectedRoleType] = useState("");
  const [selectedRoleId, setSelectedRoleId] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [hierarchyList, setHierarchyList] = useState([]);
  const [cfcsList, setcfcsList] = useState([]);
  const [circleList, setCircleList] = useState([]);
  const [divisionList, setDivisionList] = useState([]);
  const [subdivisionList, setsubDivisionList] = useState([]);
  const [successMessage, setSuccessMessage] = useState("");
  const [openSuccessModal, setOpenSuccessModal] = useState(false);
  const [supportCenterName, setSupportCenterName] = useState("-");
  const [isLoadingCfcName, setIsLoadingCfcName] = useState(false);
  const [technicalLevels, setTechnicalLevels] = useState([
    {
      value: 1,
      label: "PITC",
    },
    {
      value: 2,
      label: "DISCO",
    },
    {
      value: 3,
      label: "Circle",
    },
    {
      value: 4,
      label: "Division",
    },
    {
      value: 52,
      label: "Sub Division",
    },
  ]);
  const [cfcLevelList, setCFCLevelList] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [allRoles, setAllRoles] = useState();
  const [propertyDocuments, setPropertDocuments] = useState("");
  const [propertyDocumentError, setPropertyDocumentError] = useState("");
  const [propertyDocumentsThumbnail, setPropertyDocumentsThumbnail] =
    useState("");
  const errorCloses = () => {
    setApiError("");
  };
  const handleCloseName = () => {
    setOpenProfileModalName(false);
    nameFormik.resetForm(); // reset form values to initial
    setSelectedUser(null); // clear selected user
    setEditableFields({
      // reset editable state
      name: false,
      phoneNo: false,
      CNIC: false,
      email: false,
    });
    setApiError("");
  };
  const handleClosePhoneNo = () => {
    setOpenProfileModalPhoneNo(false);
    phoneNoFormik.resetForm(); // reset form values to initial
    setSelectedUser(null); // clear selected user
    setEditableFields({
      // reset editable state
      name: false,
      phoneNo: false,
      CNIC: false,
      email: false,
    });
    setApiError("");
  };
  const handleCloseEmail = () => {
    setOpenProfileModalEmail(false);
    gmailFormik.resetForm(); // reset form values to initial
    setSelectedUser(null); // clear selected user
    setEditableFields({
      // reset editable state
      name: false,
      phoneNo: false,
      CNIC: false,
      email: false,
    });
    setApiError("");
  };
  const handleCloseCNIC = () => {
    setOpenProfileModalCNIC(false);
    cnicFormik.resetForm(); // reset form values to initial
    setSelectedUser(null); // clear selected user
    setEditableFields({
      // reset editable state
      name: false,
      phoneNo: false,
      CNIC: false,
      email: false,
    });
    setApiError("");
  };

  // const handleCloseTransferPosting = () => {
  //     setOpenProfileModalTransferPosting(false);
  //     transferPostingFormik.resetForm();   // reset form values to initial
  //     setSelectedUser(null);    // clear selected user
  //     setPropertDocuments("");
  //     setPropertyDocumentsThumbnail("");
  //     setPropertyDocumentError("");
  //     setApiError("");
  // };
  //#endregion
  const toggleEdit = (field) => {
    setEditableFields((prev) => ({
      ...prev,
      [field]: !prev[field],
    }));
  };
  useEffect(() => {
    if (users) {
      apiToDataGridConversion();
    }
  }, [users]);
  const initialValues = {
    iv_new_password: "",
    iv_confirm_password: "",
    iv_remarks: "",
    iv_full_name: "",
    iv_full_name_remarks: "",
  };
  const passwordChangeFormik = useFormik({
    initialValues,
    validationSchema: Yup.object({
      iv_new_password: Yup.string()
        .matches(
          passwordRegex,
          "Password must contain at least one uppercase letter, one lowercase letter, one number, one special character, and must be at least 8 characters long",
        )
        .required("Password is required"),
      iv_confirm_password: Yup.string()
        .oneOf(
          [Yup.ref("iv_new_password"), null],
          "Password and Confirm password must match",
        )
        .required("Confirm password is required"),
      iv_remarks: Yup.string()
        .max(100, "Remarks can be max 100 characters long.")
        .required("Remarks are required."),
    }),
    onSubmit: async (values, { resetForm }) => {
      setViewBackdrop(true);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
        userId: selectedUserId,
        password: values.iv_new_password,
        remarks: values.iv_remarks,
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      await fetch(
        cfpBaseUrl + "customerFaciliationPortal/changePasswordofUser",
        requestOptions,
      )
        .then((response) => response.json())
        .then((result) => {
          if (result.status === "200") {
            resetForm();
            setShowChangePasswordPopup(false);
            setShowSuccessSnackbar(true);
            setTimeout(() => {
              setShowChangePasswordPopup(false);
            }, 300);
          } else if (result.status === "400") {
            setApiError(result.message);
          }
        })
        .catch((error) => console.error(error));
      setViewBackdrop(false);
    },
  });

  const nameFormik = useFormik({
    initialValues: {
      iv_full_name: "",
      iv_full_name_remarks: "",
    },
    validationSchema: Yup.object({
      iv_full_name: Yup.string()
        .min(3, "Name should be at least 3 characters.")
        .max(30, "Name should be less than 30 characters.")
        .required("Enter name."),
      iv_full_name_remarks: Yup.string()
        .min(5, "Remarks should be at least 5 characters.")
        .max(200, "Remarks should not exceed 200 characters.")
        .required("Enter remarks."),
    }),
    validateOnChange: true,
    validateOnBlur: true,
    onSubmit: async (values, { setSubmitting, setErrors, setTouched }) => {
      console.log("Form submitted with values:", values);
      setViewBackdrop(true);
      try {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
          userId: selectedUser.userId,
          name: values.iv_full_name,
          remarks: values.iv_full_name_remarks,
        });

        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        };

        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/changeNameofUser",
          requestOptions,
        );
        const result = await response.json();

        if (result.status === "200") {
          setOpenProfileModalName(false);
          nameFormik.resetForm();
          setSelectedUser(null);
          // window.location.reload();
          setSuccessMessage(result.message || "Name updated successfully!");
          setOpenSuccessModal(true);
          dispatch(
            fetchPaginatedUsers({
              officeCode,
              pageNumber,
              pageSize,
              searchParameter: values.iv_search_user || "",
            }),
          );
          setFieldValue("iv_search_user", "");
          setEditableFields((prev) => ({
            ...prev,
            name: false,
          }));
        } else {
          setApiError(result.message || "Failed to update.");
        }
      } catch (e) {
        setApiError("Unable to update name!");
        console.error("Error during submission:", e);
      }
      setViewBackdrop(false);
      setSubmitting(false);
    },
  });

  const phoneNoFormik = useFormik({
    initialValues: {
      iv_phone_no: "",
      iv_phone_no_remarks: "",
    },
    validationSchema: Yup.object({
      iv_phone_no: Yup.string()
        .required("Please enter valid mobile number.")
        .matches(/^03\d{9}$/, "Enter phone number as 03001234567"),
      iv_phone_no_remarks: Yup.string()
        .min(5, "Remarks should be at least 5 characters.")
        .max(200, "Remarks should not exceed 200 characters.")
        .required("Enter remarks."),
    }),
    validateOnChange: true,
    validateOnBlur: true,
    onSubmit: async (values, { setSubmitting, setErrors, setTouched }) => {
      console.log("Form submitted with values:", values);
      setViewBackdrop(true);
      try {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
          userId: selectedUser.userId,
          phoneNo: values.iv_phone_no,
          remarks: values.iv_phone_no_remarks,
        });

        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        };

        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/changePhoneNoofUser",
          requestOptions,
        );
        const result = await response.json();

        if (result.status === "200") {
          setOpenProfileModalPhoneNo(false);
          phoneNoFormik.resetForm();
          setSelectedUser(null);
          // window.location.reload();
          setSuccessMessage(
            result.message || "Phone No. updated successfully!",
          );
          setOpenSuccessModal(true);
          dispatch(
            fetchPaginatedUsers({
              officeCode,
              pageNumber,
              pageSize,
              searchParameter: values.iv_search_user || "",
            }),
          );
          setFieldValue("iv_search_user", "");
          setEditableFields((prev) => ({
            ...prev,
            phoneNo: false,
          }));
        } else {
          setApiError(result.message || "Failed to update.");
        }
      } catch (e) {
        setApiError("Unable to update name!");
        console.error("Error during submission:", e);
      }
      setViewBackdrop(false);
      setSubmitting(false);
    },
  });

  const gmailFormik = useFormik({
    initialValues: {
      iv_gmail: "",
      iv_gmail_remarks: "",
    },
    validationSchema: Yup.object({
      iv_gmail: Yup.string()
  .email("Invalid email format")
  .required("Email is required"),
      iv_gmail_remarks: Yup.string()
        .min(5, "Remarks should be at least 5 characters.")
        .max(200, "Remarks should not exceed 200 characters.")
        .required("Enter remarks."),
    }),
    validateOnChange: true,
    validateOnBlur: true,
    onSubmit: async (values, { setSubmitting, setErrors, setTouched }) => {
      console.log("Form submitted with values:", values);
      setViewBackdrop(true);
      try {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
          userId: selectedUser.userId,
          email: values.iv_gmail,
          remarks: values.iv_gmail_remarks,
        });

        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        };

        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/changeEmailofUser",
          requestOptions,
        );
        const result = await response.json();

        if (result.status === "200") {
          setOpenProfileModalEmail(false);
          gmailFormik.resetForm();
          setSelectedUser(null);
          // window.location.reload();
          setSuccessMessage(result.message || "Email updated successfully!");
          setOpenSuccessModal(true);
          dispatch(
            fetchPaginatedUsers({
              officeCode,
              pageNumber,
              pageSize,
              searchParameter: values.iv_search_user || "",
            }),
          );
          setFieldValue("iv_search_user", "");
          setEditableFields((prev) => ({
            ...prev,
            email: false,
          }));
        } else {
          setApiError(result.message || "Failed to update.");
        }
      } catch (e) {
        setApiError("Unable to update name!");
        console.error("Error during submission:", e);
      }
      setViewBackdrop(false);
      setSubmitting(false);
    },
  });

  const cnicFormik = useFormik({
    initialValues: {
      iv_cnic: "",
      iv_cnic_remarks: "",
    },
    validationSchema: Yup.object({
      iv_cnic: Yup.string()
        .min(13, "Please enter 13 digit CNIC.")
        .max(13, "Please enter 13 digit CNIC.")
        .required("Please enter valid CNIC number.")
        .matches(/^[0-9]+$/, "Enter CNIC number as 3520212345678."),
      iv_cnic_remarks: Yup.string()
        .min(5, "Remarks should be at least 5 characters.")
        .max(200, "Remarks should not exceed 200 characters.")
        .required("Enter remarks."),
    }),
    validateOnChange: true,
    validateOnBlur: true,
    onSubmit: async (values, { setSubmitting, setErrors, setTouched }) => {
      console.log("Form submitted with values:", values);
      setViewBackdrop(true);
      try {
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
          userId: selectedUser.userId,
          CNIC: values.iv_cnic,
          remarks: values.iv_cnic_remarks,
        });

        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        };

        const response = await fetch(
          cfpBaseUrl + "customerFaciliationPortal/changeCNICofUser",
          requestOptions,
        );
        const result = await response.json();

        if (result.status === "200") {
          setOpenProfileModalCNIC(false);
          cnicFormik.resetForm();
          setSelectedUser(null);
          // window.location.reload();
          setSuccessMessage(result.message || "CNIC. updated successfully!");
          setOpenSuccessModal(true);
          dispatch(
            fetchPaginatedUsers({
              officeCode,
              pageNumber,
              pageSize,
              searchParameter: values.iv_search_user || "",
            }),
          );
          setFieldValue("iv_search_user", "");
          setEditableFields((prev) => ({
            ...prev,
            CNIC: false,
          }));
        } else {
          setApiError(result.message || "Failed to update.");
        }
      } catch (e) {
        setApiError("Unable to update name!");
        console.error("Error during submission:", e);
      }
      setViewBackdrop(false);
      setSubmitting(false);
    },
  });

  // const handleNextPage = () => {
  //     setViewBackdrop(true)
  //     dispatch(nextPage());
  // };

  // const handlePreviousPage = () => {
  //     setViewBackdrop(true)
  //     dispatch(previousPage());
  // };

  // const handleFirstPage = () => {
  //     setViewBackdrop(true)
  //     dispatch(firstPage());
  // };

  // const handleLastPage = () => {
  //     setViewBackdrop(true)
  //     dispatch(lastPage(totalPages)); // Replace '2' with actual value
  // };

  const handleNextPage = () => {
    setViewBackdrop(true);
    dispatch(nextPage());

    dispatch(
      fetchPaginatedUsers({
        officeCode,
        pageNumber: pageNumber + 1,
        pageSize,
        searchParameter: values.iv_search_user || "",
      }),
    );
  };

  const handlePreviousPage = () => {
    setViewBackdrop(true);
    dispatch(previousPage());

    dispatch(
      fetchPaginatedUsers({
        officeCode,
        pageNumber: pageNumber - 1,
        pageSize,
        searchParameter: values.iv_search_user || "",
      }),
    );
  };

  const handleFirstPage = () => {
    setViewBackdrop(true);
    dispatch(firstPage());

    dispatch(
      fetchPaginatedUsers({
        officeCode,
        pageNumber: 1,
        pageSize,
        searchParameter: values.iv_search_user || "",
      }),
    );
  };

  const handleLastPage = () => {
    setViewBackdrop(true);
    dispatch(lastPage(totalPages));

    dispatch(
      fetchPaginatedUsers({
        officeCode,
        pageNumber: totalPages,
        pageSize,
        searchParameter: values.iv_search_user || "",
      }),
    );
  };

  // useEffect(() => {
  //     dispatch(fetchPaginatedUsers({ officeCode: officeCode, pageNumber: pageNumber, pageSize: pageSize }))
  // }, [pageNumber, pageSize])

  useEffect(() => {
    dispatch(
      fetchPaginatedUsers({
        officeCode,
        pageNumber,
        pageSize,
        searchParameter: values.iv_search_user || "",
      }),
    );
  }, [pageNumber, pageSize]);

  const filterNCApp = (userId) => {
    if (users) {
      let itemFound = users.find((item) => item.userId === userId);
      return itemFound;
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleClose2 = () => {
    setopen2(false);
  };

  const onDelete = async () => {
    var formdata = new FormData();
    formdata.append("toBeDeletedUserId", dltuser);
    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);

    var requestOptions = {
      method: "POST",
      body: formdata,
      headers: myHeaders,
      redirect: "follow",
    };

    await fetch(
      cfpBaseUrl + "customerFaciliationPortal/deleteUser",
      requestOptions,
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "200") {
          dispatch(
            fetchPaginatedUsers({
              officeCode: officeCode,
              pageNumber: pageNumber,
              pageSize: pageSize,
            }),
          );
        } else {
        }
      })
      .catch((error) => console.log("error", error));
    handleClose2();
  };

  const convertDate = (dateString) => {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const date = new Date(dateString);
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const convertdatetime = (datetimestring) => {
    if (datetimestring) {
      const converted = moment(datetimestring).format("llll");
      return converted;
    }
  };

  const callChangeStatusApi = async (user) => {
    console.log(user, "printing user");

    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      status: user.status === true ? 0 : 1,
      userId: user.userId,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    await fetch(
      cfpBaseUrl + "customerFaciliationPortal/markActiveInactiveUser",
      requestOptions,
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "200") {
          dispatch(
            fetchPaginatedUsers({
              officeCode: officeCode,
              pageNumber: pageNumber,
              pageSize: pageSize,
            }),
          );
        } else {
        }
      })
      .catch((error) => console.log("error", error));
  };

  const callResetLoginAttemptsApi = async (params) => {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      userId: params.userId,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      cfpBaseUrl + "customerFaciliationPortal/resetLoginAttempts",
      requestOptions,
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "200") {
          dispatch(
            fetchPaginatedUsers({
              officeCode: officeCode,
              pageNumber: pageNumber,
              pageSize: pageSize,
            }),
          );
        } else {
        }
      })
      .catch((error) => console.error(error));
  };

  const CustomButton = styled(Button)({
    boxShadow: "none",
    textTransform: "none",
    fontSize: 13,
    padding: "6px 5px",
    border: "1px solid",
    color: "white",
    width: "2px",
    lineHeight: 1,
    backgroundColor: "#2e7d32",
    borderColor: "#2e7d32",
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:hover": {
      backgroundColor: "#1b5e20",
      borderColor: "#1b5e20",
      color: "white",
      boxShadow: "none",
    },
  });

  const tblColumns = [
    // { field: "id", headerName: 'ID', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
    {
      field: "completename",
      headerName: "Full Name",
      align: "left",
      sortable: false,
      headerStyle: tableStyle.headerStyle,
      headerCellStyle: tableStyle.headerCellStyle,
      rowCellStyle: tableStyle.rowCellStyle,
    },
    {
      field: "userId",
      headerName: "Username",
      align: "left",
      sortable: false,
      headerStyle: tableStyle.headerStyle,
      headerCellStyle: tableStyle.headerCellStyle,
      rowCellStyle: tableStyle.rowCellStyle,
    },
    {
      field: "code",
      headerName: "Office Code",
      align: "left",
      sortable: false,
      headerStyle: tableStyle.headerStyle,
      headerCellStyle: tableStyle.headerCellStyle,
      rowCellStyle: tableStyle.rowCellStyle,
    },
    // { field: "roleType", headerName: 'roleType', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
    {
      field: "roles",
      headerName: "Roles",
      align: "left",
      sortable: false,
      headerStyle: tableStyle.headerStyle,
      headerCellStyle: tableStyle.headerCellStyle,
      rowCellStyle: tableStyle.rowCellStyle,
    },
    // { field: "created by", headerName: 'Creator', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
    // { field: "created at", headerName: 'Created', align: 'center', headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
    {
      field: "last login attempt at",
      headerName: "Last Login Attempt at",
      align: "left",
      sortable: false,
      headerStyle: tableStyle.headerStyle,
      headerCellStyle: tableStyle.headerCellStyle,
      rowCellStyle: tableStyle.rowCellStyle,
    },
    {
      field: "loginattempts",
      headerName: "Login Attempts",
      align: "center",
      sortable: false,
      headerStyle: tableStyle.headerStyle,
      headerCellStyle: tableStyle.headerCellStyle,
      rowCellStyle: tableStyle.rowCellStyle,
      renderCell: (params) => {
        return (
          <div
            style={{ width: "100%", display: "flex", justifyContent: "center" }}
          >
            {params.loginattempts > 2 ? (
              <LockResetIcon
                onClick={() => callResetLoginAttemptsApi(params)}
                sx={{ color: "#be032d" }}
              />
            ) : (
              <Person4OutlinedIcon sx={{ color: "#4caf50" }} />
            )}
          </div>
        );
      },
    },
    {
      field: "button",
      headerName: "Inactive | Active",
      align: "center",
      headerStyle: tableStyle.headerStyle,
      headerCellStyle: tableStyle.headerCellStyle,
      rowCellStyle: tableStyle.rowCellStyle,
      sortable: false,
      renderCell: (params) => {
        return (
          <div
            style={{ width: "100%", display: "flex", justifyContent: "center" }}
          >
            <ToggleButton
              accountStatus={params.status}
              onChange={() => callChangeStatusApi(params)}
            />
          </div>
        );
      },
    },
    {
      field: "button",
      headerName: "Change Password ",
      align: "center",
      sortable: false,
      headerStyle: tableStyle.headerStyle,
      headerCellStyle: tableStyle.headerCellStyle,
      rowCellStyle: tableStyle.rowCellStyle,
      renderCell: (params) => {
        return (
          <div
            style={{ width: "100%", display: "flex", justifyContent: "center" }}
          >
            <IconButton
              aria-label="delete"
              size="small"
              sx={{ margin: 0.4, padding: 0 }}
            >
              <PasswordRoundedIcon
                sx={{ color: "#e25316ff" }}
                onClick={() => {
                  setSelectedUserId(params.userId);
                  setShowChangePasswordPopup(true);
                }}
                alt="Change Password"
                style={{ width: "24px", height: "24px" }}
              />
            </IconButton>
          </div>
        );
      },
    },
    {
      headerName: "Action",
      sortable: false,
      align: "center",
      field: "buttons",
      headerStyle: tableStyle.headerStyle,
      headerCellStyle: tableStyle.headerCellStyle,
      rowCellStyle: tableStyle.rowCellStyle,
      renderCell: (params) => {
        const open = Boolean(anchorEl);
        const onViewUser = async (e) => {
          e.stopPropagation();

          const item = filterNCApp(params.userId);
          setDialogRowData(item);
          console.log(item, "item");

          const selectedUserCompany = item.companyCode;

          try {
            if (officeCode === "10" && selectedUserCompany) {
              setViewBackdrop(true);

              const formdataSubDivisions = new FormData();
              formdataSubDivisions.append("companyCode", selectedUserCompany);

              const myHeaders = new Headers();
              myHeaders.append("Authorization", token);

              const requestOptionsSubDivisions = {
                method: "POST",
                body: formdataSubDivisions,
                headers: myHeaders,
                redirect: "follow",
              };

              const response = await fetch(
                cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails",
                requestOptionsSubDivisions,
              );

              const result = await response.json();

              if (result.status === "200") {
                setSubDivisions(result.message);
              }
            }
          } catch (error) {
            console.log("API Error:", error);
          } finally {
            setViewBackdrop(false);
          }

          setOpen(true);
        };

        const onDeleteUser = (e) => {
          e.stopPropagation();
          setopen2(true);
          setdltuser(params.userId);
        };
        const onEditUser = (e) => {
          e.stopPropagation();
          const userToEdit = filterNCApp(params.userId);
          console.log(userToEdit, "userToEdit");
          Navigate("/user-management/update-user", { state: { userToEdit } });
        };
        const onSessionKill = (e) => {
          e.stopPropagation();
        };

        const handleMenuOpen = (e) => {
          e.stopPropagation();
          const userToEdit = filterNCApp(params.userId);
          console.log("Change Profile for selectedUser", userToEdit);

          setSelectedUser(userToEdit);
          setAnchorEl(e.currentTarget);
        };

        const handleMenuClose = () => {
          setAnchorEl(null);
        };

        const handleChangeProfileName = () => {
          handleMenuClose();
          console.log("Change Profile for", selectedUser);
          nameFormik.values.iv_full_name = selectedUser.name;
          setOpenProfileModalName(true);
        };
        const handleChangeProfilePhoneNo = () => {
          handleMenuClose();
          console.log("Change Profile for", selectedUser);
          phoneNoFormik.values.iv_phone_no = selectedUser.phoneNo;
          setOpenProfileModalPhoneNo(true);
        };

        const handleChangeProfileEmail = () => {
          handleMenuClose();
          console.log("Change Profile for", selectedUser);
          gmailFormik.values.iv_gmail = selectedUser.email;
          setOpenProfileModalEmail(true);
        };

        const handleChangeProfileCNIC = () => {
          handleMenuClose();
          console.log("Change Profile for", selectedUser);
          cnicFormik.values.iv_cnic = selectedUser.CNIC;
          setOpenProfileModalCNIC(true);
        };

        const handleChangeTransferPosting = () => {
          setOpenTransferPopup(true);
        };

        const handleChangeRole = () => {
          handleMenuClose();
          console.log("Change Role for", selectedUser);
        };
        return (
          <>
            <Box>
              {/* <IconButton onClick={onSessionKill} aria-label="delete" size="small" sx={{ margin: 0, padding: 0 }}>
                                <ClearIcon fontSize="inherit" sx={{ color: 'orange' }} />
                            </IconButton> */}
              {CheckPermissions(
                permissions,
                "Access Management",
                "User Management",
                "CSD Management",
                "Read",
              ) &&
              CheckPermissions(
                permissions,
                "Access Management",
                "User Management",
                "RO Management",
                "Read",
              ) &&
              CheckPermissions(
                permissions,
                "Access Management",
                "User Management",
                "CSC Admin Management",
                "Read",
              ) &&
              CheckPermissions(
                permissions,
                "Access Management",
                "User Management",
                "CSR Management",
                "Read",
              ) ? (
                <IconButton
                  onClick={onViewUser}
                  aria-label="delete"
                  size="small"
                  sx={{ margin: 0.4, padding: 0 }}
                >
                  <VisibilityIcon
                    sx={{ color: "skyblue" }}
                    fontSize="inherit"
                  />
                </IconButton>
              ) : null}

              {/* Previous Edit Option */}

              {/* {CheckPermissions(
                permissions,
                "Access Management",
                "User Management",
                "CSD Management",
                "Update",
              ) &&
              CheckPermissions(
                permissions,
                "Access Management",
                "User Management",
                "RO Management",
                "Update",
              ) &&
              CheckPermissions(
                permissions,
                "Access Management",
                "User Management",
                "CSC Admin Management",
                "Update",
              ) &&
              CheckPermissions(
                permissions,
                "Access Management",
                "User Management",
                "CSR Management",
                "Update",
              ) ? (
                <IconButton
                  onClick={onEditUser}
                  aria-label="delete"
                  size="small"
                  sx={{ margin: 0.4, padding: 0 }}
                >
                  <EditIcon fontSize="inherit" sx={{ color: "blue" }} />
                </IconButton>
              ) : null} */}

              {/* Delete  */}
              {/* {
                                CheckPermissions(permissions, 'Access Management', 'User Management', 'CSD Management', 'Delete') &&
                                    CheckPermissions(permissions, 'Access Management', 'User Management', 'RO Management', 'Delete') &&
                                    CheckPermissions(permissions, 'Access Management', 'User Management', 'CSC Admin Management', 'Delete') &&
                                    CheckPermissions(permissions, 'Access Management', 'User Management', 'CSR Management', 'Delete') ?
                                    <IconButton aria-label="delete" size="small" sx={{ margin: 0, padding: 0 }} onClick={onDeleteUser}>
                                        <DeleteIcon fontSize="inherit" sx={{ color: 'red' }} />
                                    </IconButton> : null
                            } */}
              {CheckPermissions(
                permissions,
                "Access Management",
                "User Management",
                "CSD Management",
                "Read",
              ) &&
              CheckPermissions(
                permissions,
                "Access Management",
                "User Management",
                "RO Management",
                "Read",
              ) &&
              CheckPermissions(
                permissions,
                "Access Management",
                "User Management",
                "CSC Admin Management",
                "Read",
              ) &&
              CheckPermissions(
                permissions,
                "Access Management",
                "User Management",
                "CSR Management",
                "Read",
              ) ? (
                <>
                  <IconButton
                    onClick={handleMenuOpen}
                    aria-label="more"
                    size="small"
                    sx={{ margin: 0.4, padding: 0 }}
                  >
                    <EditIcon fontSize="inherit" sx={{ color: "#006ad1" }} />
                  </IconButton>
                  <Menu
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleMenuClose}
                    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                    transformOrigin={{ vertical: "top", horizontal: "right" }}
                    PaperProps={{
                      elevation: 0,
                      sx: {
                        border: `1px solid ${colors.white}`,
                        boxShadow: "none",
                      },
                    }}
                    MenuListProps={{
                      sx: {
                        padding: 0,
                      },
                    }}
                  >
                    <MenuItem
                      disableRipple
                      sx={{
                        justifyContent: "start",
                        fontWeight: "bold",
                        fontSize: "1rem",
                        color: colors.white,
                        backgroundColor: colors.primaryBlue,
                        pointerEvents: "none",
                        "&:hover": {
                          backgroundColor: colors.primaryBlue,
                          color: colors.white,
                        },
                      }}
                    >
                      Edit Profile{" "}
                      {selectedUser ? `(${selectedUser.userId})` : ""} <br />
                    </MenuItem>

                    <MenuItem
                      onClick={handleChangeProfileName}
                      sx={{
                        "&:hover": {
                          backgroundColor: "#d5e5ff",
                          color: "#1f7cd6",
                        },
                      }}
                    >
                      <ListItemIcon>
                        <DriveFileRenameOutlineIcon
                          fontSize="small"
                          sx={{ color: "#eb7b30ff" }}
                        />
                      </ListItemIcon>
                      <ListItemText primary="Change Name" />
                    </MenuItem>

                    <MenuItem
                      sx={{
                        "&:hover": {
                          backgroundColor: "#d5e5ff",
                          color: "#1f7cd6",
                        },
                      }}
                      onClick={handleChangeProfilePhoneNo}
                    >
                      <ListItemIcon>
                        <LocalPhoneIcon
                          fontSize="small"
                          sx={{ color: "#4caf50" }}
                        />
                      </ListItemIcon>
                      <ListItemText primary="Change Phone No" />
                    </MenuItem>

                    <MenuItem
                      sx={{
                        "&:hover": {
                          backgroundColor: "#d5e5ff",
                          color: "#1f7cd6",
                        },
                      }}
                      onClick={handleChangeProfileEmail}
                    >
                      <ListItemIcon>
                        <EmailIcon
                          fontSize="small"
                          sx={{ color: "#d46759ff" }}
                        />
                      </ListItemIcon>
                      <ListItemText primary="Change Email" />
                    </MenuItem>

                    <MenuItem
                      sx={{
                        "&:hover": {
                          backgroundColor: "#d5e5ff",
                          color: "#1f7cd6",
                        },
                      }}
                      onClick={handleChangeProfileCNIC}
                    >
                      <ListItemIcon>
                        <ContactEmergencyIcon
                          fontSize="small"
                          sx={{ color: "#4caf50" }}
                        />
                      </ListItemIcon>
                      <ListItemText primary="Change CNIC" />
                    </MenuItem>

                    <MenuItem
                      sx={{
                        "&:hover": {
                          backgroundColor: "#d5e5ff",
                          color: "#1f7cd6",
                        },
                      }}
                      onClick={handleChangeTransferPosting}
                    >
                      <ListItemIcon>
                        <TransferWithinAStationIcon
                          fontSize="small"
                          sx={{ color: "#4caf50" }}
                        />
                      </ListItemIcon>
                      <ListItemText primary="Transfer Posting" />
                    </MenuItem>
                  </Menu>
                </>
              ) : null}
            </Box>
          </>
        );
      },
    },
  ];

  const apiToDataGridConversion = () => {
    const myArray = users;
    const tempArray = [];
    if (myArray) {
      //for(let i = 0; i <= myArray.length; i++){
      myArray.forEach((item) => {
        const dataGridObject = {
          // "id": item.id,
          completename: item.name,
          userId: item.userId,
          code: item.code,
          // "roleType": item.roleTypeId == "1" ? "Commercial" : item.roleTypeId == "2" ? "Technical" : '',
          roles: item.roleName,
          "created by": item.created_by,
          "created at": convertDate(item.created_at),
          "last login attempt at": item.lastLoginAttemptTime
            ? item.lastLoginAttemptTime
            : "-",
          status: item.status == "1" ? true : false,
          loginattempts: item.loginAttempts,
        };
        tempArray.push(dataGridObject);
      });
    } else {
      const dataGridObject = {
        // "id": ' ',
        connectionType: "",
        applicantName: " ",
        applicantCNIC: " ",
        applicationStatusId: statusFunc(" "),
      };
      tempArray.push(dataGridObject);
    }
    setNewUsersToDataGrid(tempArray);
    setViewBackdrop(false);
  };

  const statusFunc = (x) => {
    if (x === 0) {
      return "Pending";
    } else if (x === 1) {
      return "In Process";
    } else if (x === 2) {
      return "Approved";
    }
  };

  const getCompanyName = (code) => {
    let companyObject = subDivisions.find((item) => item.companyCode === code);
    if (companyObject) {
      return companyObject.companyName;
    }
  };
  const getCircleName = (code) => {
    let circleObject = subDivisions.find((item) => item.circleCode === code);
    if (circleObject) {
      return circleObject.circleName;
    }
  };
  const getDivisionName = (code) => {
    let divisionObject = subDivisions.find(
      (item) => item.divisionCode === code,
    );
    if (divisionObject) {
      return divisionObject.divisionName;
    }
  };
  const getSubDivisionName = (code) => {
    let subDivisionObject = subDivisions.find(
      (item) => item.subDivisionCode === code,
    );
    if (subDivisionObject) {
      return subDivisionObject.subDivisionName;
    }
  };
  const getSupportCenterName = async (code) => {
    if (!code) return "-";

    const prefix = String(code).slice(0, 2);
    const allSupportCenters = await AllCFCs(token, permissions, prefix);

    if (!allSupportCenters || !Array.isArray(allSupportCenters)) {
      console.warn("AllCFCs returned invalid data", allSupportCenters);
      return "N/A";
    }

    const supportCenter = allSupportCenters.find(
      (item) => Number(item.cfcId) === Number(code),
    );

    if (!supportCenter) {
      console.warn(`No CFC found for cscId: ${code}`);
      return "Not Found";
    }

    // Try multiple possible field names
    const name =
      supportCenter.cfcName ||
      supportCenter.name ||
      supportCenter.centerName ||
      supportCenter.description ||
      "Unnamed CFC";

    return name;
  };

  // const { values, errors, touched, handleBlur, handleChange, handleSubmit } = useFormik({
  //     initialValues: {
  //         iv_search_user: '',
  //     },
  //     validationSchema: Yup.object().shape({
  //         iv_search_user: Yup.string().min(3, 'Search term must be max atleast 3 characters.').max(20, 'Search term can be max 20 characters.').required('User ID is required.'),
  //     }),
  //     onSubmit: (values) => {
  //         console.log(values.iv_search_user,"values.iv_search_user")
  //         dispatch(fetchPaginatedUsers({ officeCode: officeCode, pageNumber: pageNumber, pageSize: pageSize, searchParameter: values.iv_search_user }))
  //     }
  // });

  // useEffect(() => {
  //     if (!values.iv_search_user) {
  //         dispatch(fetchPaginatedUsers({ officeCode: officeCode, pageNumber: 1, pageSize: 20 }))
  //     }
  // }, [values.iv_search_user])
  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    setFieldValue,
    resetForm,
  } = useFormik({
    initialValues: {
      iv_search_user: "",
    },
    validationSchema: Yup.object().shape({
      iv_search_user: Yup.string()
        .min(3, "Search term must be at least 3 characters.")
        .max(20, "Search term can be max 20 characters.")
        .required("User id is required."),
    }),
    onSubmit: (values) => {
      console.log(values.iv_search_user);
    },
  });

  // const handleInputChange = (e) => {
  //     const { value } = e.target;
  //     setSearchTerm(value);

  //     if (typingTimeout) {
  //         clearTimeout(typingTimeout);
  //     }

  //     const timeout = setTimeout(() => {
  //         dispatch(fetchPaginatedUsers({
  //             officeCode,
  //             pageNumber,
  //             pageSize,
  //             searchParameter: value
  //         }))
  //             .unwrap()
  //             .then((response) => {
  //                 if (response?.status === 'Data Not Found.') {
  //                     setNoDataFound(true);
  //                 } else {
  //                     setNoDataFound(false);
  //                 }
  //             })
  //             .catch((error) => {
  //                 console.error('Fetch error:', error);
  //                 setNoDataFound(true);
  //             });
  //     }, 500);

  //     setTypingTimeout(timeout);
  // };

  const handleInputChange = (e) => {
    const { value } = e.target;
    setSearchTerm(value);

    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }

    // 👇 Reset to page 1 before making search API call
    dispatch(firstPage());

    const timeout = setTimeout(() => {
      dispatch(
        fetchPaginatedUsers({
          officeCode,
          pageNumber: 1, // ⬅️ Force page 1 for all search inputs
          pageSize,
          searchParameter: value,
        }),
      )
        .unwrap()
        .then((response) => {
          if (response?.status === "Data Not Found.") {
            setNoDataFound(true);
          } else {
            setNoDataFound(false);
          }
        })
        .catch((error) => {
          console.error("Fetch error:", error);
          setNoDataFound(true);
        });
    }, 500);

    setTypingTimeout(timeout);
  };

  useEffect(() => {
    if (!values.iv_search_user) {
      setNoDataFound(false);
      dispatch(
        fetchPaginatedUsers({
          officeCode: officeCode,
          pageNumber: 1,
          pageSize: 20,
        }),
      );
    }
  }, [values.iv_search_user]);

  useEffect(() => {
    const loadCfcName = async () => {
      if (!open || !dialogRowData?.cscId) {
        setSupportCenterName("-");
        return;
      }

      setIsLoadingCfcName(true);
      try {
        const name = await getSupportCenterName(dialogRowData.cscId);
        setSupportCenterName(name);
      } catch (err) {
        console.error("Failed to load CFC name:", err);
        setSupportCenterName("Error");
      } finally {
        setIsLoadingCfcName(false);
      }
    };

    loadCfcName();
  }, [open, dialogRowData?.cscId]);

  return (
    <>
      {/* {console.log(transferPostingFormik.values, "rendering")} */}
      <Box className="form-box">
        <div
          style={{
            display: "flex",
            gap: "10px",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h3 className="page-title">User Management</h3>

          {/* <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                        <div style={{
                            backgroundColor: 'white',
                            display: 'flex',
                            alignItems: 'center',
                            borderRadius: '10px',
                            padding: '5px 10px',
                            border: '1px solid grey',
                            margin: '10px 12px 0 12px'
                        }}>
                            <input
                                type="text"
                                value={values.iv_search_user}
                                name="iv_search_user"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                placeholder="Enter Search term..."
                                maxLength={20}
                                style={{
                                    flex: 1,
                                    padding: '8px',
                                    border: 'none',
                                    backgroundColor: 'transparent',
                                    outline: 'none',
                                    fontSize: '14px',
                                    minWidth: '150px'
                                }}
                            />
                            <SearchIcon
                                sx={{
                                    backgroundColor: '#09669d',
                                    color: 'white',
                                    width: 35,
                                    height: 35,
                                    borderRadius: '8px',
                                    padding: '6px',
                                    cursor: 'pointer',
                                    transition: 'background-color 0.3s',
                                    '&:hover': {
                                        backgroundColor: '#074f7d'
                                    }
                                }}
                                onClick={handleSubmit}
                            />
                        </div>

                        {errors.iv_search_user && touched.iv_search_user && (
                            <Box className="form-error" sx={{ color: 'red', fontSize: '12px', marginTop: '5px', marginLeft: '15px' }}>
                                {errors.iv_search_user}
                            </Box>
                        )}
                    </div> */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              marginBottom: "10px",
            }}
          >
            <div
              style={{
                backgroundColor: "white",
                display: "flex",
                alignItems: "center",
                borderRadius: "10px",
                padding: "5px 10px",
                border: "1px solid grey",
                margin: "2px 0px 10px 0px;",
              }}
            >
              <input
                type="text"
                value={values.iv_search_user}
                name="iv_search_user"
                onChange={(e) => {
                  handleChange(e);
                  handleInputChange(e);
                }}
                onBlur={handleBlur}
                placeholder="Search by Username,Role,Complete Name..."
                maxLength={20}
                style={{
                  flex: 1,
                  padding: "8px",
                  border: "none",
                  backgroundColor: "transparent",
                  outline: "none",
                  fontSize: "13px",
                  minWidth: "250px",
                }}
              />
              <SearchIcon
                sx={{
                  // backgroundColor: '#09669d',
                  color: "#09669d",
                  width: 30,
                  height: 30,
                  borderRadius: "8px",
                  padding: "6px",
                  cursor: "pointer",
                  transition: "background-color 0.3s",
                  "&:hover": {
                    color: "#074f7d",
                  },
                }}
                // onClick={handleSubmit}
              />
            </div>

            {errors.iv_search_user && touched.iv_search_user && (
              <Box
                className="form-error"
                sx={{
                  color: "red",
                  fontSize: "12px",
                  marginTop: "5px",
                  marginLeft: "15px",
                }}
              >
                {errors.iv_search_user}
              </Box>
            )}
          </div>
        </div>

        <Box className="application-table">
          <div style={{ position: "relative" }}>
            <BasicTable
              data={noDataFound ? [] : newusersToDataGrid}
              columns={tblColumns}
              sx={tableStyle}
              rowHeight={37.5}
              pageSize={20}
              totalPages={noDataFound ? "1" : totalPages}
              totalRecords={totalRecords}
              currentPage={noDataFound ? "1" : currentPage}
              firstPage={handleFirstPage}
              nextPage={handleNextPage}
              previousPage={handlePreviousPage}
              lastPage={handleLastPage}
              handleRowClick={() => {}}
              rowsPerPageOptions={[18, 30, 60]}
              rowsPageOption={false}
              isLoading={isLoad}
              getRowStyle={(params) => {
                return params.indexRelativeToCurrentPage % 2 === 0
                  ? tableStyle.evenRow
                  : tableStyle.oddRow;
              }}
            />
          </div>
        </Box>
      </Box>

      {/* <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                PaperProps={{ sx: { width: '85%',  maxWidth: 800,borderRadius: 3 } }} // increased width
            >
                <DialogTitle id="alert-dialog-title" sx={{ position: 'relative' }}>
                    <IconButton onClick={handleClose} sx={{ position: 'absolute', right: 8, top: 8 }}>
                        <CloseIcon />
                    </IconButton>
                    <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                        User Details
                    </Typography>
                </DialogTitle>

                <DialogContent>
                    <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
                        <img
                            src={
                                typeof dialogRowData.profilePicture === 'string'
                                    ? dialogRowData.profilePicture
                                    : dialogRowData.profilePicture
                                        ? URL.createObjectURL(dialogRowData.profilePicture)
                                        : UserIconImage
                            }
                            alt="avatar"
                            width={170}
                            height={170}
                            onError={(e) => {
                                e.target.src = UserIconImage;
                            }}
                            style={{ borderRadius: '50%' }}
                        />
                    </Box>
                    <hr></hr>

                    <Grid container spacing={2}>
                        {[
                            // { label: 'ID', value: dialogRowData.id },
                            { label: 'Name', value: dialogRowData.name },
                            { label: 'Username', value: dialogRowData.userId },
                            { label: 'Email', value: dialogRowData.email },
                            { label: 'Phone No', value: dialogRowData.phoneNo },
                            { label: 'CNIC', value: dialogRowData.CNIC },
                            { label: 'Status', value: 'Active' },
                            { label: 'Role', value: dialogRowData.roleName },
                            // { label: 'Confirmed', value: 'Yes' },
                            { label: 'Created By', value: dialogRowData.created_by },
                            { label: 'Created At', value: convertdatetime(dialogRowData.created_at) },
                            { label: 'Last Updated By', value: dialogRowData.updated_by },
                            { label: 'Last Updated At', value: dialogRowData.updated_at },
                            { label: 'Company', value: getCompanyName(dialogRowData.companyCode) || 'PITC' },
                            ...(dialogRowData.hierarchy >= 3
                                ? [{ label: 'Circle', value: getCircleName(dialogRowData.circleCode) }]
                                : []),
                            ...(dialogRowData.hierarchy >= 4
                                ? [{ label: 'Division', value: getDivisionName(dialogRowData.divisionCode) }]
                                : []),
                            ...(dialogRowData.hierarchy === 51
                                ? [{ label: 'Support Center', value: getSupportCenterName(dialogRowData.cscId) }]
                                : []),
                            ...(dialogRowData.hierarchy === 52
                                ? [{ label: 'Sub Division', value: getSubDivisionName(dialogRowData.subDivisionCode) }]
                                : []),
                        ].map((item, index) => (
                            <Grid item xs={12} sm={6} md={4} lg={6} key={index}>
                                <label style={{ fontWeight: 600 }}>{item.label}</label>
                                <TextField
                                    value={item.value}
                                    fullWidth
                                    disabled
                                    sx={{
                                        mt: 0.5,
                                        '.MuiInputBase-input': { height: '1.2rem' },
                                    }}
                                />
                            </Grid>
                        ))}
                    </Grid>

                </DialogContent>
            </Dialog> */}

      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth="sm"
        PaperProps={{ sx: { borderRadius: 3, maxWidth: 1000 } }}
        className="alert-popups"
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
          className="dialog-title"
        >
          User Profile
          <Box>
            <IconButton
              onClick={handleClose}
              sx={{ color: "white", cursor: "pointer" }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>

        <DialogContent className="dialog-content">
          <DialogContentText sx={{ minHeight: 300 }}>
            <form>
              <Grid container spacing={2} sx={{ padding: "20px" }}>
                <Grid
                  item
                  xs={12}
                  sx={{ display: "flex", justifyContent: "center" }}
                >
                  <Box
                    sx={{
                      p: 1,
                      border: "2px solid #006ad1",
                      borderRadius: 2,
                      position: "relative",
                    }}
                  >
                    <img
                      src={
                        typeof dialogRowData.profilePicture === "string"
                          ? dialogRowData.profilePicture
                          : dialogRowData.profilePicture
                            ? URL.createObjectURL(dialogRowData.profilePicture)
                            : UserIconImage
                      }
                      alt="avatar"
                      style={{
                        width: 120,
                        height: 120,
                        objectFit: "cover",
                      }}
                      onError={(e) => (e.target.src = UserIconImage)}
                    />
                  </Box>
                </Grid>

                <Grid item xs={12} sx={{ mt: 3 }}>
                  <Grid container spacing={2}>
                    <Grid
                      item
                      lg={12}
                      sx={{
                        backgroundColor: "#d5e5ff",
                        padding: "5px",
                        fontSize: "1.25rem",
                      }}
                    >
                      <h4 style={{ color: "#006ad1" }}>User Information</h4>
                    </Grid>

                    {/* Dynamic fields mapping */}
                    {[
                      // { label: 'ID', value: dialogRowData.id },
                      { label: "Username", value: dialogRowData.userId || "-" },
                      { label: "Name", value: dialogRowData.name || "-" },
                      { label: "Email", value: dialogRowData.email || "-" },
                      {
                        label: "Phone No",
                        value: dialogRowData.phoneNo || "-",
                      },
                      { label: "CNIC", value: dialogRowData.CNIC || "-" },
                      { label: "Role", value: dialogRowData.roleName || "-" },
                      {
                        label: "Status",
                        value:
                          dialogRowData.status === true
                            ? "Active"
                            : dialogRowData.status === false
                              ? "Inactive"
                              : "-",
                      },
                      // { label: 'Confirmed', value: 'Yes' },
                      {
                        label: "Created By",
                        value: dialogRowData.created_by || "-",
                      },
                      {
                        label: "Created At",
                        value: convertdatetime(dialogRowData.created_at) || "-",
                      },
                      {
                        label: "Last Updated By",
                        value: dialogRowData.updated_by || "-",
                      },
                      {
                        label: "Last Updated At",
                        value: convertdatetime(dialogRowData.updated_at) || "-",
                      },
                      {
                        label: "Company",
                        value:
                          getCompanyName(dialogRowData.companyCode) || "PITC",
                      },
                      ...(dialogRowData.hierarchy >= 3
                        ? [
                            {
                              label: "Circle",
                              value:
                                getCircleName(dialogRowData.circleCode) || "-",
                            },
                          ]
                        : []),
                      ...(dialogRowData.hierarchy === 4 ||
                      dialogRowData.hierarchy === 51 ||
                      dialogRowData.hierarchy === 52 ||
                      dialogRowData.hierarchy === 5
                        ? [
                            {
                              label: "Division",
                              value:
                                getDivisionName(dialogRowData.divisionCode) ||
                                "-",
                            },
                          ]
                        : []),
                      ...(dialogRowData.hierarchy === 52 ||
                      dialogRowData.hierarchy === 5
                        ? [
                            {
                              label: "Sub Division",
                              value:
                                getSubDivisionName(
                                  dialogRowData.subDivisionCode,
                                ) || "-",
                            },
                          ]
                        : []),
                      ...(dialogRowData?.cscId &&
                      dialogRowData?.roleTypeId === 1
                        ? [
                            {
                              label: "Customer Support Center",
                              value: isLoadingCfcName
                                ? "Loading..."
                                : supportCenterName,
                            },
                          ]
                        : []),
                    ].map((item, index) => (
                      <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                        <label style={{ fontWeight: 600 }}>{item.label}</label>
                        <TextField
                          value={item.value}
                          fullWidth
                          disabled
                          sx={{
                            mt: 0.5,
                            ".MuiInputBase-input": { height: "1.2rem" },
                          }}
                        />
                      </Grid>
                    ))}
                  </Grid>
                </Grid>
              </Grid>
            </form>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {/* You can add buttons here if needed */}
        </DialogActions>
      </Dialog>

      <Dialog
        open={open2}
        onClose={handleClose2}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {" Are you sure to delete this record"}
        </DialogTitle>
        <DialogActions>
          <Button onClick={handleClose2}>Cancel</Button>
          <Button onClick={onDelete} autoFocus>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={showChangePasswordPopup}
        onClose={() => (
          setShowChangePasswordPopup(false),
          setSelectedUserId(null),
          (passwordChangeFormik.values.iv_new_password = ""),
          (passwordChangeFormik.values.iv_confirm_password = ""),
          (passwordChangeFormik.values.iv_remarks = "")
        )}
        fullWidth={true}
        maxWidth="xs"
        className="alert-popups"
      >
        <DialogTitle
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
          className="dialog-title"
        >
          Change Password
          <Box sx={{ marginTop: "1%" }}>
            <CloseIcon
              id="clearPopup"
              onClick={() => (
                setShowChangePasswordPopup(false),
                setSelectedUserId(null),
                (passwordChangeFormik.values.iv_new_password = ""),
                (passwordChangeFormik.values.iv_confirm_password = ""),
                (passwordChangeFormik.values.iv_remarks = "")
              )}
              sx={{ color: "white", cursor: "pointer" }}
            />
          </Box>
        </DialogTitle>
        <DialogContent className="dialog-content">
          <DialogContentText>
            <form className="complaintform">
              <Grid container sx={{ padding: "20px" }}>
                <Grid item lg={12}>
                  <Grid container spacing={1}>
                    <Grid item lg={12}>
                      <Grid container spacing={1}>
                        <Grid item lg={12}>
                          <label>New Password</label>
                          <TextField
                            type={showNewPassword ? "text" : "password"}
                            autoComplete="off"
                            onChange={passwordChangeFormik.handleChange}
                            name="iv_new_password"
                            value={passwordChangeFormik.values.iv_new_password}
                            onBlur={passwordChangeFormik.handleBlur}
                            sx={{
                              width: "100%",
                              ".MuiInputBase-input": {
                                height: ".5vh",
                              },
                            }}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <IconButton
                                    onClick={handleClickShowNewPassword}
                                    edge="end"
                                  >
                                    {!showNewPassword ? (
                                      <Visibility />
                                    ) : (
                                      <VisibilityOff />
                                    )}
                                  </IconButton>
                                </InputAdornment>
                              ),
                            }}
                          />
                          <Grid>
                            {passwordChangeFormik.errors.iv_new_password &&
                            passwordChangeFormik.touched.iv_new_password ? (
                              <p style={{ color: "#f73232", fontSize: "1rem" }}>
                                {passwordChangeFormik.errors.iv_new_password}
                              </p>
                            ) : null}
                          </Grid>
                        </Grid>
                        <Grid item lg={12}>
                          <label>Confirm New Password</label>
                          <TextField
                            type={showConfirmPassword ? "text" : "password"}
                            autoComplete="off"
                            onChange={passwordChangeFormik.handleChange}
                            name="iv_confirm_password"
                            value={
                              passwordChangeFormik.values.iv_confirm_password
                            }
                            onBlur={passwordChangeFormik.handleBlur}
                            sx={{
                              width: "100%",
                              ".MuiInputBase-input": {
                                height: ".5vh",
                              },
                            }}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <IconButton
                                    onClick={handleClickShowConfirmPassword}
                                    edge="end"
                                  >
                                    {!showConfirmPassword ? (
                                      <Visibility />
                                    ) : (
                                      <VisibilityOff />
                                    )}
                                  </IconButton>
                                </InputAdornment>
                              ),
                            }}
                          />
                          <Grid>
                            {passwordChangeFormik.errors.iv_confirm_password &&
                            passwordChangeFormik.touched.iv_confirm_password ? (
                              <p style={{ color: "#f73232", fontSize: "1rem" }}>
                                {
                                  passwordChangeFormik.errors
                                    .iv_confirm_password
                                }
                              </p>
                            ) : null}
                          </Grid>
                        </Grid>
                        <Grid item lg={12}>
                          <label>Remarks</label>
                          <TextField
                            sx={{
                              width: "100%",
                              ".MuiInputBase-input": {
                                height: ".5vh",
                              },
                            }}
                            required
                            type="text"
                            autoComplete="off"
                            name="iv_remarks"
                            value={passwordChangeFormik.values.iv_remarks}
                            onChange={passwordChangeFormik.handleChange}
                            onBlur={passwordChangeFormik.handleBlur}
                            id="iv_remarks"
                            className="textInputField"
                          />
                          <Grid>
                            {passwordChangeFormik.errors.iv_remarks &&
                            passwordChangeFormik.touched.iv_remarks ? (
                              <p style={{ color: "#f73232", fontSize: "1rem" }}>
                                {passwordChangeFormik.errors.iv_remarks}
                              </p>
                            ) : null}
                          </Grid>
                        </Grid>

                        <Grid item lg={12}>
                          {apiError && (
                            <Error
                              error={apiError}
                              onClose={() => errorCloses()}
                              backgroundColor="#FFC0CB"
                              textColor="#bb0303"
                              iconColor="#bb0303"
                            />
                          )}
                        </Grid>
                        <Grid
                          item
                          lg={12}
                          sx={{ display: "flex", justifyContent: "flex-end" }}
                        >
                          <Button
                            sx={{ width: "30%" }}
                            variant="contained"
                            size="medium"
                            onClick={passwordChangeFormik.handleSubmit}
                          >
                            Submit
                          </Button>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </form>
          </DialogContentText>
        </DialogContent>
      </Dialog>

      <Dialog
        open={openProfileModalName}
        onClose={() => setOpenProfileModalName(false)}
        fullWidth
        maxWidth="sm"
        className="alert-popups"
      >
        <DialogTitle
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
          className="dialog-title"
        >
          Edit Name
          <Box sx={{ marginTop: "1%" }}>
            <CloseIcon
              id="clearPopup"
              onClick={handleCloseName}
              sx={{ color: "white", cursor: "pointer" }}
            />
          </Box>
        </DialogTitle>
        <DialogContent dividers>
          <form
            onSubmit={(e) => {
              e.preventDefault(); // Prevent default to debug
              nameFormik.handleSubmit();
              console.log("Formik state after submit:", {
                values: nameFormik.values,
                errors: nameFormik.errors,
                touched: nameFormik.touched,
              });
            }}
          >
            <Grid container spacing={2}>
              {/* Full Name */}
              <Grid item lg={12} xs={12}>
                <label>Full Name</label>
                <TextField
                  type="text"
                  disabled={!editableFields.name}
                  onChange={nameFormik.handleChange}
                  onBlur={nameFormik.handleBlur}
                  name="iv_full_name"
                  value={nameFormik.values.iv_full_name}
                  fullWidth
                  autoComplete="off"
                  sx={{
                    ".MuiInputBase-input": {
                      height: ".5vh",
                      backgroundColor: "white",
                    },
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        {!editableFields.name && (
                          <IconButton
                            onClick={() => toggleEdit("name")}
                            edge="end"
                          >
                            <EditIcon />
                          </IconButton>
                        )}
                      </InputAdornment>
                    ),
                  }}
                />
                {nameFormik.touched.iv_full_name &&
                  nameFormik.errors.iv_full_name && (
                    <p style={{ color: "#f73232", fontSize: "0.9rem" }}>
                      {nameFormik.errors.iv_full_name}
                    </p>
                  )}
              </Grid>

              {/* Remarks */}
              <Grid item lg={12}>
                <label>Remarks</label>
                <TextField
                  fullWidth
                  autoComplete="off"
                  name="iv_full_name_remarks"
                  value={nameFormik.values.iv_full_name_remarks}
                  onChange={nameFormik.handleChange}
                  onBlur={nameFormik.handleBlur}
                  id="iv_full_name_remarks"
                />
                {nameFormik.touched.iv_full_name_remarks &&
                  nameFormik.errors.iv_full_name_remarks && (
                    <p style={{ color: "#f73232", fontSize: "1rem" }}>
                      {nameFormik.errors.iv_full_name_remarks}
                    </p>
                  )}
              </Grid>
              <Grid item lg={12}>
                {apiError && (
                  <Error
                    error={apiError}
                    onClose={() => errorCloses()}
                    backgroundColor="#FFC0CB"
                    textColor="#bb0303"
                    iconColor="#bb0303"
                  />
                )}
              </Grid>
              {/* Save Button */}
              <Grid
                item
                lg={12}
                sx={{ display: "flex", justifyContent: "flex-end" }}
              >
                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  disabled={
                    nameFormik.values.iv_full_name === selectedUser?.name
                  }
                >
                  Save
                </Button>
              </Grid>
            </Grid>
          </form>
        </DialogContent>
      </Dialog>

      <Dialog
        open={openProfileModalPhoneNo}
        onClose={() => setOpenProfileModalPhoneNo(false)}
        fullWidth
        maxWidth="sm"
        className="alert-popups"
      >
        <DialogTitle
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
          className="dialog-title"
        >
          Edit Phone No
          <Box sx={{ marginTop: "1%" }}>
            <CloseIcon
              id="clearPopup"
              onClick={handleClosePhoneNo}
              sx={{ color: "white", cursor: "pointer" }}
            />
          </Box>
        </DialogTitle>
        <DialogContent dividers>
          <form
            onSubmit={(e) => {
              e.preventDefault(); // Prevent default to debug
              phoneNoFormik.handleSubmit();
              console.log("Formik state after submit:", {
                values: phoneNoFormik.values,
                errors: phoneNoFormik.errors,
                touched: phoneNoFormik.touched,
              });
            }}
          >
            <Grid container spacing={2}>
              {/* Phone No */}
              <Grid item lg={12} xs={12}>
                <label>Phone No</label>
                <TextField
                  type="text"
                  disabled={!editableFields.phoneNo}
                  onChange={(e) => {
                    // remove non-digits in real time
                    const value = e.target.value.replace(/\D/g, "");
                    phoneNoFormik.setFieldValue("iv_phone_no", value);
                  }}
                  onBlur={phoneNoFormik.handleBlur}
                  name="iv_phone_no"
                  value={phoneNoFormik.values.iv_phone_no}
                  inputProps={{ maxLength: 11 }}
                  fullWidth
                  autoComplete="off"
                  sx={{
                    ".MuiInputBase-input": {
                      height: ".5vh",
                      backgroundColor: "white",
                    },
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        {!editableFields.phoneNo && (
                          <IconButton
                            onClick={() => toggleEdit("phoneNo")}
                            edge="end"
                          >
                            <EditIcon />
                          </IconButton>
                        )}
                      </InputAdornment>
                    ),
                  }}
                />
                {phoneNoFormik.touched.iv_phone_no &&
                  phoneNoFormik.errors.iv_phone_no && (
                    <p style={{ color: "#f73232", fontSize: "0.9rem" }}>
                      {phoneNoFormik.errors.iv_phone_no}
                    </p>
                  )}
              </Grid>

              {/* Remarks */}
              <Grid item lg={12}>
                <label>Remarks</label>
                <TextField
                  fullWidth
                  autoComplete="off"
                  name="iv_phone_no_remarks"
                  value={phoneNoFormik.values.iv_phone_no_remarks}
                  onChange={phoneNoFormik.handleChange}
                  onBlur={phoneNoFormik.handleBlur}
                  id="iv_phone_no_remarks"
                />
                {phoneNoFormik.touched.iv_phone_no_remarks &&
                  phoneNoFormik.errors.iv_phone_no_remarks && (
                    <p style={{ color: "#f73232", fontSize: "1rem" }}>
                      {phoneNoFormik.errors.iv_phone_no_remarks}
                    </p>
                  )}
              </Grid>
              <Grid item lg={12}>
                {apiError && (
                  <Error
                    error={apiError}
                    onClose={() => errorCloses()}
                    backgroundColor="#FFC0CB"
                    textColor="#bb0303"
                    iconColor="#bb0303"
                  />
                )}
              </Grid>
              {/* Save Button */}
              <Grid
                item
                lg={12}
                sx={{ display: "flex", justifyContent: "flex-end" }}
              >
                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  disabled={
                    phoneNoFormik.values.iv_phone_no === selectedUser?.phoneNo
                  }
                >
                  Save
                </Button>
              </Grid>
            </Grid>
          </form>
        </DialogContent>
      </Dialog>

      <Dialog
        open={openProfileModalEmail}
        onClose={() => setOpenProfileModalEmail(false)}
        fullWidth
        maxWidth="sm"
        className="alert-popups"
      >
        <DialogTitle
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
          className="dialog-title"
        >
          Edit Email
          <Box sx={{ marginTop: "1%" }}>
            <CloseIcon
              id="clearPopup"
              onClick={handleCloseEmail}
              sx={{ color: "white", cursor: "pointer" }}
            />
          </Box>
        </DialogTitle>
        <DialogContent dividers>
          <form
            onSubmit={(e) => {
              e.preventDefault(); // Prevent default to debug
              gmailFormik.handleSubmit();
              console.log("Formik state after submit:", {
                values: gmailFormik.values,
                errors: gmailFormik.errors,
                touched: gmailFormik.touched,
              });
            }}
          >
            <Grid container spacing={2}>
              {/* Phone No */}
              <Grid item lg={12} xs={12}>
                <label>Email</label>
                <TextField
                  type="text"
                  disabled={!editableFields.email}
                  onChange={gmailFormik.handleChange}
                  onBlur={gmailFormik.handleBlur}
                  name="iv_gmail"
                  value={gmailFormik.values.iv_gmail}
                  fullWidth
                  autoComplete="off"
                  sx={{
                    ".MuiInputBase-input": {
                      height: ".5vh",
                      backgroundColor: "white",
                    },
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        {!editableFields.email && (
                          <IconButton
                            onClick={() => toggleEdit("email")}
                            edge="end"
                          >
                            <EditIcon />
                          </IconButton>
                        )}
                      </InputAdornment>
                    ),
                  }}
                />
                {gmailFormik.touched.iv_gmail &&
                  gmailFormik.errors.iv_gmail && (
                    <p style={{ color: "#f73232", fontSize: "0.9rem" }}>
                      {gmailFormik.errors.iv_gmail}
                    </p>
                  )}
              </Grid>

              {/* Remarks */}
              <Grid item lg={12}>
                <label>Remarks</label>
                <TextField
                  fullWidth
                  autoComplete="off"
                  name="iv_gmail_remarks"
                  value={gmailFormik.values.iv_gmail_remarks}
                  onChange={gmailFormik.handleChange}
                  onBlur={gmailFormik.handleBlur}
                  id="iv_gmail_remarks"
                />
                {gmailFormik.touched.iv_gmail_remarks &&
                  gmailFormik.errors.iv_gmail_remarks && (
                    <p style={{ color: "#f73232", fontSize: "1rem" }}>
                      {gmailFormik.errors.iv_gmail_remarks}
                    </p>
                  )}
              </Grid>
              <Grid item lg={12}>
                {apiError && (
                  <Error
                    error={apiError}
                    onClose={() => errorCloses()}
                    backgroundColor="#FFC0CB"
                    textColor="#bb0303"
                    iconColor="#bb0303"
                  />
                )}
              </Grid>
              {/* Save Button */}
              <Grid
                item
                lg={12}
                sx={{ display: "flex", justifyContent: "flex-end" }}
              >
                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  disabled={gmailFormik.values.iv_gmail === selectedUser?.email}
                >
                  Save
                </Button>
              </Grid>
            </Grid>
          </form>
        </DialogContent>
      </Dialog>

      <Dialog
        open={openProfileModalCNIC}
        onClose={() => setOpenProfileModalCNIC(false)}
        fullWidth
        maxWidth="sm"
        className="alert-popups"
      >
        <DialogTitle
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
          className="dialog-title"
        >
          Edit CNIC
          <Box sx={{ marginTop: "1%" }}>
            <CloseIcon
              id="clearPopup"
              onClick={handleCloseCNIC}
              sx={{ color: "white", cursor: "pointer" }}
            />
          </Box>
        </DialogTitle>
        <DialogContent dividers>
          <form
            onSubmit={(e) => {
              e.preventDefault(); // Prevent default to debug
              cnicFormik.handleSubmit();
              console.log("Formik state after submit:", {
                values: cnicFormik.values,
                errors: cnicFormik.errors,
                touched: cnicFormik.touched,
              });
            }}
          >
            <Grid container spacing={2}>
              {/* Phone No */}
              <Grid item lg={12} xs={12}>
                <label>CNIC</label>
                <TextField
                  type="text"
                  disabled={!editableFields.CNIC}
                  onChange={(e) => {
                    // remove non-digits in real time
                    const value = e.target.value.replace(/\D/g, "");
                    cnicFormik.setFieldValue("iv_cnic", value);
                  }}
                  onBlur={cnicFormik.handleBlur}
                  name="iv_cnic"
                  value={cnicFormik.values.iv_cnic}
                  fullWidth
                  autoComplete="off"
                  inputProps={{ maxLength: 13 }}
                  sx={{
                    ".MuiInputBase-input": {
                      height: ".5vh",
                      backgroundColor: "white",
                    },
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        {!editableFields.CNIC && (
                          <IconButton
                            onClick={() => toggleEdit("CNIC")}
                            edge="end"
                          >
                            <EditIcon />
                          </IconButton>
                        )}
                      </InputAdornment>
                    ),
                  }}
                />
                {cnicFormik.touched.iv_cnic && cnicFormik.errors.iv_cnic && (
                  <p style={{ color: "#f73232", fontSize: "0.9rem" }}>
                    {cnicFormik.errors.iv_cnic}
                  </p>
                )}
              </Grid>

              {/* Remarks */}
              <Grid item lg={12}>
                <label>Remarks</label>
                <TextField
                  fullWidth
                  autoComplete="off"
                  name="iv_cnic_remarks"
                  value={cnicFormik.values.iv_cnic_remarks}
                  onChange={cnicFormik.handleChange}
                  onBlur={cnicFormik.handleBlur}
                  id="iv_cnic_remarks"
                />
                {cnicFormik.touched.iv_cnic_remarks &&
                  cnicFormik.errors.iv_cnic_remarks && (
                    <p style={{ color: "#f73232", fontSize: "1rem" }}>
                      {cnicFormik.errors.iv_cnic_remarks}
                    </p>
                  )}
              </Grid>
              <Grid item lg={12}>
                {apiError && (
                  <Error
                    error={apiError}
                    onClose={() => errorCloses()}
                    backgroundColor="#FFC0CB"
                    textColor="#bb0303"
                    iconColor="#bb0303"
                  />
                )}
              </Grid>
              {/* Save Button */}
              <Grid
                item
                lg={12}
                sx={{ display: "flex", justifyContent: "flex-end" }}
              >
                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  disabled={cnicFormik.values.iv_cnic === selectedUser?.CNIC}
                >
                  Save
                </Button>
              </Grid>
            </Grid>
          </form>
        </DialogContent>
      </Dialog>
      <Modal
        open={openTransferSuccessModal}
        onClose={() => {
          setOpenTransferSuccessModal(false);
          setTransferSuccessMessage("");
          // Optional: refresh table after success
          dispatch(
            fetchPaginatedUsers({
              officeCode,
              pageNumber,
              pageSize,
              searchParameter: values.iv_search_user || "",
            }),
          );
          window.location.reload();
        }}
        aria-labelledby="success-modal-title"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
            textAlign: "center",
          }}
        >
          <CheckCircleIcon
            sx={{
              fontSize: "2.5rem",
              color: "#2e7d32",
            }}
          />
          <Typography
            id="success-modal-title"
            variant="h6"
            component="h2"
            gutterBottom
          >
            Success!
          </Typography>
          <Typography color="text.secondary">
            {transferSuccessMessage || "Transfer posted successfully."}
          </Typography>
        </Box>
      </Modal>
      <UpdateUserPopup
        open={openTransferPopup}
        onClose={() => {
          setOpenTransferPopup(false);
          setSelectedUser(null);
          setAnchorEl(null);
        }}
        userToEdit={selectedUser}
        onTransferSuccess={(message) => {
          setTransferSuccessMessage(message);
          setOpenTransferSuccessModal(true);
        }}
        // onUpdated can stay if you still use it for other cases
        onUpdated={() => {
          dispatch(
            fetchPaginatedUsers({
              officeCode,
              pageNumber,
              pageSize,
              searchParameter: values.iv_search_user || "",
            }),
          );
        }}
      />

      <Modal
        open={openSuccessModal}
        onClose={() => setOpenSuccessModal(false)}
        aria-labelledby="success-modal-title"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
            textAlign: "center",
          }}
        >
          <CheckCircleIcon
            sx={{
              fontSize: "2.5rem",
              color: "#2e7d32",
            }}
          />
          <Typography
            id="success-modal-title"
            variant="h6"
            component="h2"
            gutterBottom
          >
            Success!
          </Typography>

          <Typography color="text.secondary">{successMessage}</Typography>
        </Box>
      </Modal>
      <Snackbar
        open={showSuccessSnackbar}
        autoHideDuration={3000}
        onClose={() => setShowSuccessSnackbar(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        sx={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
      >
        <Alert
          onClose={() => setShowSuccessSnackbar(false)}
          severity="success"
          sx={{ width: "100%" }}
        >
          Password Changed Successfully.
        </Alert>
      </Snackbar>
      {/* Backdrop */}
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1000 }}
        open={viewBackdrop}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
}
